import { render } from "./btn-preload.vue?vue&type=template&id=60f04fe2&scoped=true"
import script from "./btn-preload.vue?vue&type=script&lang=js"
export * from "./btn-preload.vue?vue&type=script&lang=js"

import "./btn-preload.vue?vue&type=style&index=0&id=60f04fe2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f04fe2"]])

export default __exports__